<template>
  <b-container fluid id="observation-recommendations" class="mt-4">
    <b-row>
      <b-col>
        <div id="alerts" ref="trainer-observations-alert">
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged"
            >You have successfully added a COVID observation!</b-alert
          >
          <b-alert :show="showError" dismissible variant="warning">
            Something went wrong. Please refresh and try again, or contact the
            site admin.
          </b-alert>
        </div>
        <div id="recommendation-form">
          <b-row id="headers" class="mt-2 mb-2">
            <b-col>Date</b-col>
            <b-col>School</b-col>
            <b-col>Teacher</b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group labelFor="observation-date">
                <b-form-input
                  name="observation-date"
                  type="date"
                  v-model="dateForm"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="school-select">
                <b-form-select name="school" v-model="schoolForm">
                  <option disabled value>Select a School</option>
                  <option
                    v-for="school in trainerSchools"
                    :key="school.uuid"
                    :value="school.uuid"
                    >{{ school.school_name }}</option
                  >
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="teacher-select">
                <b-form-select
                  name="teacher"
                  v-model="teacherForm"
                  :state="teacherInput"
                >
                  <option disabled value>Select a Teacher</option>
                  <option
                    v-for="teacher in schoolTeachers"
                    :key="teacher.uuid"
                    :value="teacher.uuid"
                  >
                    {{ teacher.first_name }} {{ teacher.middle_name }}
                    {{ teacher.last_name }} - head teacher:
                    {{ teacher.head_teacher === true ? "Y" : "N" }}, active:
                    {{ teacher.active === true ? "Y" : "N" }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <b-form-group label="Hand Washing">
                <b-form-radio v-model="handsWashed" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="handsWashed" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Soap Supplied">
                <b-form-radio v-model="soapProvided" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="soapProvided" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Teachers Wearing Masks">
                <b-form-radio v-model="masksTeacher" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="masksTeacher" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Students Wearing Masks">
                <b-form-radio v-model="masksStudent" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="masksStudent" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Social Distancing">
                <b-form-radio v-model="socialDistancing" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="socialDistancing" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Indication of Indivudials Infected">
                <b-form-radio v-model="infected" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="infected" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Parent Covid Workshops Provided">
                <b-form-radio v-model="workshops" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="workshops" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <b-button
                v-if="isAdmin || isSRC"
                align-h="center"
                :variant="'primary'"
                @click="addOrUpdate"
                >{{ buttonTitle }}</b-button
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button
                v-if="isAdmin || isSRC"
                align-h="center"
                :variant="'primary'"
                @click="clearForm"
                >Clear</b-button
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-input-group class="mt-4">
                <b-form-input v-model="filter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
              <p class="error text-center" v-if="formError">
                There is an error with your submission. Please ensure all fields
                are completed before submitting
              </p>
              <br />
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="table-wrap mt-4">
          <b-table
            v-cloak
            responsive
            small
            :fields="fields"
            :items="obs"
            :striped="true"
            :bordered="true"
            :hover="true"
            :filter="filter"
            :current-page="currentPage"
            @filtered="onFiltered"
            :per-page="perPage"
            stacked="md"
            id="obs-table"
            style="width: 100%; white-space: nowrap; table-layout: fixed;"
          >
            <template slot="cell(school_name)" slot-scope="row" v-if="fields">
              <b-link
                :to="{
                  name: 'EditSchool',
                  params: { id: row.item.school_uuid },
                }"
                >{{ row.item.school_name }}</b-link
              >
            </template>
            <template
              style="overflow: hidden; text-overflow: ellipsis"
              slot="cell(teacher_name)"
              slot-scope="row"
              v-if="fields"
            >
              <b-link
                :to="{
                  name: 'EditTeacher',
                  params: { id: row.item.teacher_uuid },
                }"
                >{{ row.item.teacher_name }}</b-link
              >
            </template>
            <template slot="cell(id)" slot-scope="row">
              <b-link @click.stop="editRecommendation(row)">View</b-link>
            </template>
            <template slot="cell(delete)" slot-scope="row">
              <b-link
                v-if="isAdmin || isSRC"
                class="delete"
                @click.stop="deleteObservation(row.item)"
                >Delete</b-link
              >
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1">
              <b-pagination
                :total-rows="obs.length || 0"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
              />
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TrainerService from "../services/TrainerService";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "TrainerCovidObservations",
  mixins: [flash, scrollTo],
  data() {
    return {
      disabled: false,
      required: false,
      changeTitle: false,
      observationId: this.$route.params.id,
      currentPage: 1,
      perPage: 20,
      fields: [
        { key: "obs_date", label: "Date", sortable: true },
        { key: "school_name", label: "School", sortable: true },
        { key: "teacher_name", label: "Teacher", sortable: true },
        { key: "id", label: "View/Edit" },
        { key: "delete", label: "Delete" },
      ],
      id: "",
      dateForm: null,
      schoolForm: null,
      teacherForm: null,
      filter: null,
      formError: false,
      totalRows: this.rows,
      soapProvided: false,
      handsWashed: false,
      masksTeacher: false,
      masksStudent: false,
      socialDistancing: false,
      infected: false,
      workshops: false,
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
       isSRC: "auth/isSRC",
    }),
    rows() {
      if (this.obs) {
        return this.obs.length;
      }
    },
    buttonTitle() {
      return this.changeTitle ? "Save" : "Submit";
    },
    obs() {
      const data = this.observations.map((k) => ({
        teacher_name: `${k.first_name} ${k.last_name}`,
        id: k.id,
        obs_date: k.obs_date,
        school_uuid: k.school_uuid,
        school_name: k.school_name,
        teacher_uuid: k.teacher_uuid,
        soapProvided: k.soap_supplied,
        handsWashed: k.hand_washing,
        masksTeacher: k.masks_teacher,
        masksStudent: k.masks_student,
        socialDistancing: k.social_distancing,
        infected: k.individuals_infected,
        workshops: k.parent_covid_workshops_delivered,
      }));
      return data;
    },
    observations: {
      get() {
        console.log(
          "covid obs: ",
          this.$store.state.trainers.covidObservations
        );
        return this.$store.state.trainers.covidObservations;
      },
      set(val) {
        this.$store.commit("trainers/covidObservations", val);
      },
    },
    trainerSchools: {
      get() {
        return this.$store.state.trainers.trainerSchoolNames;
      },
    },
    schoolTeachers: {
      get() {
        return this.$store.state.trainers.schoolTeachers;
      },
    },
    teacherInput() {
      !!(this.schoolTeachers && this.schoolTeachers.length);
    },
  },
  methods: {
    ...mapActions({
      GET_SCHOOL_NAMES_BY_TRAINER: "trainers/GET_SCHOOL_NAMES_BY_TRAINER",
      GET_TEACHER_NAMES_BY_TRAINER_SCHOOL:
        "trainers/GET_TEACHER_NAMES_BY_TRAINER_SCHOOL",
      GET_OBSERVATIONS: "trainers/GET_TRAINER_COVID_OBSERVATIONS",
      ADD_OBSERVATIONS: "trainers/ADD_TRAINER_COVID_OBSERVATIONS",
      UPDATE_OBSERVATIONS: "trainers/UPDATE_TRAINER_COVID_OBSERVATIONS",
      GET_TRAINER_SCHOOLS: "schools/GET_TRAINER_SCHOOLS",
      GET_SCHOOL_TEACHERS: "teachers/GET_SCHOOL_TEACHERS",
    }),
    async addRecommendation() {
      if (
        this.schoolForm === null ||
        this.teacherForm === null ||
        this.dateForm === null
      ) {
        this.formError = true;
        this.flashError();
        return;
      }
      await TrainerService.addTrainerCovidObservation({
        observation_date: this.dateForm,
        trainer_uuid: this.$route.params.id,
        teacher_uuid: this.teacherForm,
        school_uuid: this.schoolForm,
        soapProvided: this.soapProvided,
        handsWashed: this.handsWashed,
        masksTeacher: this.masksTeacher,
        masksStudent: this.masksStudent,
        socialDistancing: this.socialDistancing,
        infected: this.infected,
        workshops: this.workshops,
      });
      await this.scrollTo("trainer-observations-alert");
      await this.flashSuccess();
      this.clearForm();
      this.formError = false;
      this.changeTitle = false;
      await this.GET_OBSERVATIONS();
    },
    async updateRecommendation() {
      if (
        this.schoolForm === null ||
        this.teacherForm === null ||
        this.dateForm === null
      ) {
        this.formError = true;
        this.flashError();
        return;
      }
      await TrainerService.updateTrainerCovidObservation({
        id: this.id,
        observation_date: this.dateForm,
        trainer_uuid: this.$route.params.id,
        teacher_uuid: this.teacherForm,
        school_uuid: this.schoolForm,
        supplied_soap: this.soapProvided,
        hand_washing: this.handsWashed,
        masks_teacher: this.masksTeacher,
        masks_student: this.masksStudent,
        social_distancing: this.socialDistancing,
        individuals_infected: this.infected,
        parent_covid_workshops_delivered: this.workshops,
      });
      await this.scrollTo("trainer-observations-alert");
      await this.flashSuccess();
      this.clearForm();
      this.formError = false;
      this.changeTitle = false;
      await this.GET_OBSERVATIONS();
    },
    async addOrUpdate() {
      if (this.buttonTitle === "Save") {
        this.updateRecommendation();
      } else {
        this.addRecommendation();
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    clearForm() {
      this.dateForm = null;
      this.teacherForm = "";
      this.schoolForm = "";
      this.id = "";
      this.soapProvided = false;
      this.handsWashed = false;
      this.masksTeacher = false;
      this.masksStudent = false;
      this.socialDistancing = false;
      this.infected = false;
      this.workshops = false;
    },
    editRecommendation(row) {
      console.log("row: ", row);
      this.changeTitle = true;

      this.id = row.item.id;
      this.changeTitle = true;
      this.dateForm = row.item.obs_date;
      this.teacherForm = row.item.teacher_uuid;
      this.schoolForm = row.item.school_uuid;
      this.soapProvided = row.item.soapProvided;
      this.handsWashed = row.item.handsWashed;
      this.masksTeacher = row.item.masksTeacher;
      this.masksStudent = row.item.masksStudent;
      this.socialDistancing = row.item.socialDistancing;
      this.infected = row.item.infected;
      this.workshops = row.item.workshops;
    },
    async deleteObservation(params) {
      const confirmDelete = confirm(
        "Are you sure you want to delete this Observation?"
      );
      if (confirmDelete) {
        await TrainerService.deleteTrainerCovidObservation(params.id);
        await this.GET_OBSERVATIONS();
      }
    },
  },
  watch: {
    schoolForm(val) {
      if (val.length > 0) {
        console.log(val);
        this.GET_TEACHER_NAMES_BY_TRAINER_SCHOOL(val);
      }
    },
  },
  mounted() {
    this.GET_OBSERVATIONS();
    this.GET_SCHOOL_NAMES_BY_TRAINER();
  },
};
</script>

<style scoped>
#headers,
#date {
  text-align: left;
}
#edit_icon {
  float: left;
}
#delete_icon {
  width: 20%;
}
h1,
#add_icon {
  display: inline;
}
#add_icon {
  width: 3%;
  opacity: 80%;
}
.table {
  table-layout: fixed;
}
.date-row {
  width: 50%;
}
table th,
table tr {
  text-align: center;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
table thead {
  background: #bf9660;
}
td {
  width: 100px;
  text-align: center;
}
table tr td {
  padding: 10px;
}
table tr:nth-child(odd) {
  background: #f2f2f2;
}
table tr:nth-child(1) {
  background: #bf9660;
  color: #fff;
}
a {
  color: #4d7ef7;
  text-decoration: none;
}
.error {
  color: #9e0000;
  text-align: center;
}
</style>
